import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserSettings {
  darkTheme: boolean;
  preferredLanguage: string;
}

interface UserState {
  settings: UserSettings;
  // Add other user-related properties here if needed
}

const getInitialDarkTheme = (): boolean => {
  // Auth pages are light-only; only restore cached theme for logged-in sessions.
  if (!localStorage.getItem('user')) return false;
  const stored = localStorage.getItem('darkTheme');
  return stored ? stored === 'true' : false;
};

const initialState: UserState = {
  settings: {
    darkTheme: getInitialDarkTheme(),
    preferredLanguage: 'en',
  },
  // Initialize other user-related properties here if needed
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setDarkTheme(state, action: PayloadAction<boolean>) {
      state.settings.darkTheme = action.payload;
      localStorage.setItem('darkTheme', action.payload.toString());
    },
    toggleDarkTheme(state) {
      state.settings.darkTheme = !state.settings.darkTheme;
    },
    setPreferredLanguage(state, action: PayloadAction<string>) {
      state.settings.preferredLanguage = action.payload;
    },
    setDefaultUserSettings(state) {
      state.settings = {
        darkTheme: false,
        preferredLanguage: initialState.settings.preferredLanguage,
      };
      localStorage.removeItem('darkTheme');
    },
  },
});

export const {
  setDarkTheme,
  toggleDarkTheme,
  setPreferredLanguage,
  setDefaultUserSettings,
} = userSlice.actions;
export default userSlice.reducer;
